import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    public authS: AuthenticationService
  ) {}

  canActivate(): boolean {
    return this.authS.isAuthenticated();
  }
}
